// extracted by mini-css-extract-plugin
export default {"container":"lYxYn","stakeNameContainer":"KZT68","main":"MqxSi","badges":"DWbjU","singleBadges":"FiaMl","disabledEntry":"KVyDh","notConflictedEntry":"h_7kh","footerWrapper":"qd7OD"};